export interface SpringConfig {
  damping: number
  stiffness: number
  mass: number
}

export const QUICK_SPRING: SpringConfig = {
  damping: 30,
  stiffness: 460,
  mass: 1,
}
export const MENU_SPRING: SpringConfig = {
  damping: 24,
  stiffness: 300,
  mass: 1,
}

const STEP = 1 / 1000
const REST_DISPLACEMENT = 0.0005
const REST_VELOCITY = 0.005

export class Spring {
  value: number
  velocity = 0
  target: number

  constructor(
    value: number,
    private readonly config: SpringConfig
  ) {
    this.value = value
    this.target = value
  }

  get resting() {
    return (
      Math.abs(this.target - this.value) < REST_DISPLACEMENT &&
      Math.abs(this.velocity) < REST_VELOCITY
    )
  }

  set(value: number) {
    this.value = value
    this.target = value
    this.velocity = 0
  }

  step(seconds: number) {
    if (this.resting) {
      this.value = this.target
      this.velocity = 0
      return
    }
    const { damping, stiffness, mass } = this.config
    for (let remaining = seconds; remaining > 0; remaining -= STEP) {
      const dt = Math.min(STEP, remaining)
      const force =
        -stiffness * (this.value - this.target) - damping * this.velocity
      this.velocity += (force / mass) * dt
      this.value += this.velocity * dt
    }
  }
}

export const easeInOutQuad = (t: number) =>
  t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2

export const SAMPLE_MS = 1000 / 120

export function springCurve(
  from: number,
  to: number,
  velocity: number,
  config: SpringConfig
) {
  const spring = new Spring(from, config)
  spring.target = to
  spring.velocity = velocity
  const samples = [from]
  while (!spring.resting && samples.length < 600) {
    spring.step(SAMPLE_MS / 1000)
    samples.push(spring.value)
  }
  samples[samples.length - 1] = to
  return samples
}
